'use client';
import { useEffect, useRef, useState } from 'react';
import { MuxPlayerProps, MuxPlayerRefAttributes } from '@mux/mux-player-react';
import MuxPlayer from '@mux/mux-player-react/lazy';
import { PlayToken } from '../../MuxVideoPlayer';

export interface CoursePlayerProps extends MuxPlayerProps {
  playBackTokens?: PlayToken;
  playBackId?: string;
  seekTo?: number | null;
}

export default function CoursePlayer({
  playBackTokens,
  playBackId,
  seekTo,
  ...props
}: CoursePlayerProps) {
  const playerRef = useRef<MuxPlayerRefAttributes>(null);
  const [hasWindow, setHasWindow] = useState(false);
  useEffect(() => {
    if (typeof window !== 'undefined') {
      setHasWindow(true);
    }
  }, []);

  if (!hasWindow) {
    return null;
  }

  const onPlayerStart = () => {
    if (seekTo && playerRef.current) {
      playerRef.current.currentTime = seekTo;
    }
  };

  return (
    <MuxPlayer
      ref={playerRef}
      playbackId={playBackId}
      tokens={playBackTokens}
      autoPlay={true}
      playerInitTime={0}
      onLoadedData={onPlayerStart}
      style={{ aspectRatio: 16 / 9 }}
      {...props}
    />
  );
}
